/** @format */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  jobIdState: "",
  mobileNumberState: "",
  clearFilterFlag: 0,
};

const customerJobReportsFilterSlice = createSlice({
  name: "customerJobReportsFilter",
  initialState,
  reducers: {
    setJobIdFilter(state, action) {
      state.jobIdState = action.payload;
    },
    setMobileNumberFilter(state, action) {
      state.mobileNumberState = action.payload;
    },
    setClearFilterFlag(state, action) {
      state.clearFilterFlag = action.payload;
    },
    reset(state) {
      state.jobIdState = "";
      state.mobileNumberState = "";
      state.clearFilterFlag = 0;
    },
  },
});

export const {
  setJobIdFilter,
  setMobileNumberFilter,
  reset,
  setClearFilterFlag,
} = customerJobReportsFilterSlice.actions;

export default customerJobReportsFilterSlice.reducer;
